export const videoContent = {
  
  // New upload interface translations
  readyToStart: "🎬 Vamos começar sua transformação em vídeo?",
  unlockFeatures: "Libere um editor com botões inteligentes, player customizado e máxima conversão.",
  smartButtons: "Botões Inteligentes com Tempo e Ação",
  customPlayer: "Player com sua Identidade Visual",
  personalizedCustomization: "Personalização Total",
  highConversion: "Alta Conversão Garantida",
  finalCTA: "💡 Pronto? Suba seu vídeo agora e surpreenda seus espectadores.",
  uploadVideo: "Enviar Vídeo",
  uploadDescription: "Arraste seu vídeo aqui ou clique para enviar um arquivo",
  supportedFormats: "Formatos suportados",
  formatDetails: "MP4, MOV, AVI | Máximo: 100MB",
  uploadTips: "Dica para melhor qualidade",
  uploadTipsDescription: "Vídeos em HD (1080p) oferecem melhor experiência aos espectadores",
} as const;
